import React, { Component } from 'react'
import Dashboard from '../Dashboard'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import * as serializeJavascript from '../../utils/helpers/serializeJavascript'
import SouscriptionSwitcher from '../../components/SouscriptionSwitcher'
import QuestionnaireBox from '../../components/QuestionnaireBox'
import arrow_right_img from '../../utils/assets/images/arrow-right.png'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import { fetchAddQuestionnaireAction } from '../../actions/Souscription/Questionnaire'
import { fetchBeneficiairesAction, fetchUpdateBeneficiaireAction } from '../../actions/Souscription/Beneficiaire'
import {  fetchSouscripteurAction } from '../../actions/Souscription/Souscripteur'

import {
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class Questionnaire extends Component {
  state = {
    isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier"),
    isAllBeneficiaires: false,
    allBeneficiaires: [],
    allQuestionnaires: [],
    applyRedirectPrev: false,
    applyRedirectNext: false,
    submitAllBeneficiairesSuccess: false,
    submitAllSuccess: true,
    submitBeneficiaireCount: 0,
    forms: []
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Questionnaire`

    const { isCurrentLoginCourtier } = this.state
    const { getReauthenticate, reauthenticateMembers, getReauthenticateCourtiers, reauthenticateCourtiers, userGetBeneficiaires, userGetSouscripteur } = this.props
    
    if (isCurrentLoginCourtier) {
      if (Object.keys(reauthenticateCourtiers.courtierData).length === 0) {
        getReauthenticateCourtiers()
      }

      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
        userGetBeneficiaires(reauthenticateCourtiers.courtierData.souscripteurID)
      }else {
        getReauthenticateCourtiers()
      }
    }else {
      if (Object.keys(reauthenticateMembers.userData).length === 0 || !reauthenticateMembers.userData.souscripteurID) {
        getReauthenticate()
      }
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetBeneficiaires(reauthenticateMembers.userData.souscripteurID)
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
      }
    }
  }
  componentWillUpdate(nextProps, nextState) {
    const { reauthenticateMembers, reauthenticateCourtiers, userGetBeneficiaires, getBeneficiaires, addQuestionnaire, userGetSouscripteur } = nextProps
    const { allBeneficiaires, submitBeneficiaireCount } = nextState

    if (reauthenticateMembers.userData.length !== this.props.reauthenticateMembers.userData.length) {
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetBeneficiaires(reauthenticateMembers.userData.souscripteurID)
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
      }
    }
    if (reauthenticateCourtiers.courtierData.length !== this.props.reauthenticateCourtiers.courtierData.length) {
      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
        userGetBeneficiaires(reauthenticateCourtiers.courtierData.souscripteurID)
      }
    }
    if (getBeneficiaires.beneficiairesData.length !== this.props.getBeneficiaires.beneficiairesData.length) {
      if (getBeneficiaires.beneficiairesData.data && getBeneficiaires.beneficiairesData.data !== undefined) {
        let thisAllQuestionnaires = getBeneficiaires.beneficiairesData.data.map((beneficiare, index) => {
          return beneficiare.questionnaire
        })
        this.setState({ isAllBeneficiaires: true, allBeneficiaires: [ ...getBeneficiaires.beneficiairesData.data ], allQuestionnaires: thisAllQuestionnaires })
      }
    }
    if (addQuestionnaire.isSuccess && nextState.submitAllSuccess) {
      if (submitBeneficiaireCount === 0 || submitBeneficiaireCount !== this.state.submitBeneficiaireCount) {
        let thisTotalBeneficiaires = allBeneficiaires.length
        if (thisTotalBeneficiaires > submitBeneficiaireCount) {
          this.setState({ submitBeneficiaireCount: submitBeneficiaireCount + 1 })
        }
        if ( thisTotalBeneficiaires === submitBeneficiaireCount) {
          this.setState({ submitAllBeneficiairesSuccess: thisTotalBeneficiaires === submitBeneficiaireCount, submitAllSuccess: false })
        }
      }
    }
  }
  handleChangeBeneficiaire = (beneficiaireIndex, questionnaire) => {
    const { allQuestionnaires } = this.state
    let thisAllQuestionnaires = allQuestionnaires
    thisAllQuestionnaires[beneficiaireIndex] = {...thisAllQuestionnaires[beneficiaireIndex], ...questionnaire }

    this.setState({ allQuestionnaires: thisAllQuestionnaires })
  }

  handleBeneficiairePrev = event => {
    event.preventDefault()
    const { allBeneficiaires, allQuestionnaires } = this.state
    const { userAddQuestionnaire } = this.props

    if (allBeneficiaires.length !== null) {
      for (var i = 0; i < allBeneficiaires.length; i++) {
        userAddQuestionnaire(allBeneficiaires[i]._id, serializeJavascript.sanitize(allQuestionnaires[i]))
      }
      this.setState({ applyRedirectPrev: true })
    }
  }

  handleBeneficiaireNext = event => {
    event.preventDefault()
    const { allBeneficiaires, allQuestionnaires } = this.state
    const { userAddQuestionnaire } = this.props
    if (allBeneficiaires.length !== null) {
      for (var i = 0; i < allBeneficiaires.length; i++) {
        userAddQuestionnaire(allBeneficiaires[i]._id, serializeJavascript.sanitize(allQuestionnaires[i]))
      }
      this.setState({ applyRedirectNext: true })
    }
  }
  checkFormValid = (position, isValid) => {
    this.setState((prev) => {
      prev.forms[position] = isValid
      return {forms: prev.forms}
    })
  }
  render() {
    const { match, reauthenticateMembers, reauthenticateCourtiers, getBeneficiaires, addQuestionnaire, updateBeneficiaire, getSouscripteur } = this.props
    const { allBeneficiaires, submitAllBeneficiairesSuccess, applyRedirectNext, applyRedirectPrev, isCurrentLoginCourtier } = this.state
    let invalidForm = this.state.forms.length !== 0 && !this.state.forms.reduce((a,b) => a && b)

    return(
      <div>
        <Header userIsSuccessLogin={isCurrentLoginCourtier ? reauthenticateCourtiers.isSuccess : reauthenticateMembers.isSuccess} />
          {(getSouscripteur.souscripteurData.status === "submitted" || getSouscripteur.souscripteurData.status === "payment-pending") && <Redirect to="/soumis" push/>}
          {getSouscripteur.souscripteurData.status === "police-active" && <Redirect to="/validation-souscription" push/>}
          {(reauthenticateMembers.isLoading || reauthenticateCourtiers.isLoading)
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="aps-dashboard-menu-tab-content">
                  <SouscriptionSwitcher match={match} />
                    {(getBeneficiaires.isLoading || updateBeneficiaire.isLoading || addQuestionnaire.isLoading)
                      ?
                        <div className="aps-spinner-component-loading">
                          <div className="uk-spinner">
                            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                               <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                            </svg>
                          </div>
                          <div className="aps-section-register-desc">chargement en cours</div>
                        </div>
                      :
                        <div>
                          <div className="uk-text-center aps-dashboard-questionnaire-title uk-text-bold">
                            Complétez le questionnaire médical pour chaque bénéficiaire
                          </div>
                          {(submitAllBeneficiairesSuccess && applyRedirectNext) &&
                            <div>
                              <Redirect to="/data-protection" push/>
                            </div>
                          }
                          {(submitAllBeneficiairesSuccess && applyRedirectPrev) &&
                            <div>
                              <Redirect to="/devis" push/>
                            </div>
                          }
                          {getBeneficiaires.isSuccess &&
                            <div className="aps-dashboard-beneficiare-container">
                              <ul className="aps-dashboard-beneficiare-accordion-container" data-uk-accordion>
                                {
                                  allBeneficiaires.map((beneficiare, index) => (
                                    <QuestionnaireBox
                                      key={index}
                                      beneficiairePosition={index + 1}
                                      beneficiaireData={beneficiare}
                                      checkChangeBeneficiaire={this.handleChangeBeneficiaire}
                                      checkFormValid={this.checkFormValid}
                                    />
                                  ))
                                }
                              </ul>
                            </div>
                          }
                          <div class="aps-section-questionnaire-clause-data-wrap">
                            <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                              <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                                <img src={arrow_right_img} alt="arrow-right" />
                              </div>
                              <div className="uk-width-expand aps-section-alerte-green-expand">
                                <div className="aps-section-questionnaire-clause-data-title uk-text-center uk-text-bold">
                                  Pathologies préexistantes 
                                </div>
                                <p className="aps-section-alerte-green-content-full uk-text-bold uk-text-justify">
                                  Une pathologie préexistante est un problème de santé ou problème découlant de ce dernier dont un ou plusieurs symptômes sont apparus au cours de votre
                                  vie, qu'un traitement ou conseil médical ait été recherché ou non. Tout problème de santé ou problème lié, dont vous ou vos ayants droit auraient
                                  raisonnablement pu connaître l'existence, sera considéré comme une pathologie préexistante. Les pathologies préexistantes sont couvertes par la police
                                  d’assurance, sauf indication contraire écrite de notre part, pour les polices individuelles. Les problèmes de santé apparaissant entre la date de signature du
                                  bulletin d'adhésion et la date d’effet de la police seront également considérés comme pathologies préexistantes. Ces pathologies préexistantes devront être
                                  soumises à une souscription médicale, et ne seront pas couvertes si elles ne sont pas déclarées. Pour cette raison, veuillez nous communiquer tout
                                  changement matériel survenant entre l'envoi du bulletin d'adhésion et notre acceptation. Dans le présent formulaire et à notre demande, vous êtes dans
                                  l'obligation de nous fournir toutes les informations dont nous pourrions avoir besoin. Ce formulaire doit être rempli complètement et précisément et toutes les
                                  informations pertinentes doivent être déclarées : ceci est une condition préalable à la couverture. 
                                </p>
                              </div>
                            </div>
                            <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                              <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                                <img src={arrow_right_img} alt="arrow-right" />
                              </div>
                              <div className="uk-width-expand aps-section-alerte-green-expand">
                                <div className="aps-section-questionnaire-clause-data-title uk-text-center uk-text-bold">
                                  Déclaration d’état de santé 
                                </div>
                                <p className="aps-section-alerte-green-content-full uk-text-bold uk-text-justify">
                                  Veuillez remplir le questionnaire suivant en prenant en compte l’ensemble de votre historique médical et celui de vos ayants droit. Tous les éléments matériels
                                  (éléments nous permettant d’évaluer le risque et d’accepter la souscription) doivent être communiqués à l’assureur. Ne pas les communiquer pourrait
                                  entrainer l’annulation de votre contrat ou la réduction du montant des remboursements ou leur rejet en totalité. En cas de doute, l’élément doit être déclaré.
                                  Cette déclaration d’état de santé est valable trois mois à compter de sa date de signature.
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="aps-dashboard-souscription-switch">
                            <div className="aps-dashboard-souscription-switch-btn aps-bottom-btn-text-position-second">
                              <button
                                className={`uk-button aps-btn-silver aps-btn-silver-dashboard-btn`}
                                onClick={(event) => this.handleBeneficiairePrev(event)}
                              >Section précédente</button>

                              <button
                                className={`uk-button aps-btn-green aps-btn-green-dashboard-btn  ${invalidForm ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                                disabled={this.state.forms.length !== 0 && !this.state.forms.reduce((a,b) => a && b)}
                                onClick={(event) => this.handleBeneficiaireNext(event)}
                              >Section suivante</button>
                            </div>
                          </div>
                        </div>
                    }
                </div>
                {(reauthenticateMembers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion' push/>
                  </div>
                }
                {(reauthenticateCourtiers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion-intermediaires' push/>
                  </div>
                }
              </Dashboard>
          }
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = ({ reauthenticateMembers, reauthenticateCourtiers, getSouscripteur, getBeneficiaires, addQuestionnaire, updateBeneficiaire }) => {
  return {
    reauthenticateMembers,
    reauthenticateCourtiers,
    getBeneficiaires,
    addQuestionnaire,
    updateBeneficiaire,
    getSouscripteur
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
    userGetSouscripteur: (souscripteurID) => dispatch(fetchSouscripteurAction(souscripteurID)),
    userGetBeneficiaires: (souscripteurID) => dispatch(fetchBeneficiairesAction(souscripteurID)),
    userAddQuestionnaire: (beneficiaireID, questionnaire) => dispatch(fetchAddQuestionnaireAction(beneficiaireID, questionnaire)),
    userUpdateBeneficiaire: (beneficiaireID, beneficiaireData) => dispatch(fetchUpdateBeneficiaireAction(beneficiaireID, beneficiaireData)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Questionnaire)



// WEBPACK FOOTER //
// ./src/containers/Questionnaire/index.js